export enum ETabButton {
  DEFAULT = 'default',
  LINK = 'link'
}

export type TTabButton = (typeof ETabButton)[keyof typeof ETabButton];
